import React from 'react';
import {
  TextField,
} from '@printdeal/ui-library';

import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

interface ReferenceFieldProps {
  dispatchDataLayerEvent: (field: string, value: 'click' | 'fill' | 'empty') => void;
}

const ReferenceField = ({ dispatchDataLayerEvent }: ReferenceFieldProps) => {
  const { register } = useFormContext();
  const intl = useIntl();

  return (
    <TextField
      id="reference"
      label={intl.formatMessage({ id: 'account.quotes.form.heading.reference', defaultMessage: 'Reference' })}
      placeholder={intl.formatMessage({ id: 'account.quotes.form.placeholder.reference', defaultMessage: 'Your reference' })}
      {...register('reference')}
      onBlur={(event) => dispatchDataLayerEvent('reference', event.target.value ? 'fill' : 'empty')}
      onFocus={() => dispatchDataLayerEvent('reference', 'click')}
      className="pd-max-w-lg"
    />
  );
};

export default ReferenceField;
